import "./LoadingStyle.css";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";
import CardHeader from "components/Card/CardHeader";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Loading from "../../components/Loading/Loading";
import React from "react";

class LoadingCard extends React.Component {
    render() {
        const { classes, title } = this.props;
        return (
            <div className={classes.container}>
                <GridContainer justify="center">
                    <GridItem md={5}>
                        <Card login className={`${classes[this.props.cardAnimation]}  loading-page`}>
                            <CardHeader
                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                color="info"
                            >
                                <h4 className={classes.cardTitle}>{title}</h4>
                            </CardHeader>
                            <CardBody
                                justify="center"
                                align="center"
                            >
                                <Loading className="loading" color="red" transform={1} />
                            </CardBody>
                            <CardFooter className={classes.justifyContentCenter} />
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }

}
export default LoadingCard;
